import React from 'react';
import {Button, Box} from '@material-ui/core';
import type { FC } from 'react';
import { useStyles } from './Buttons.styles';
import type { IAcceptCookiesButtonsProps } from './Buttons.types';

export const Buttons: FC<IAcceptCookiesButtonsProps> = props => {
  const { onAcceptAll, onOpenSettings } = props;
  const classes = useStyles();

  return <Box className={classes.root}>
    <Button className={classes.acceptButton} onClick={onAcceptAll}>Accept All Cookies</Button>
    <Button className={classes.settingsButton} onClick={onOpenSettings}>Cookies Settings</Button>
  </Box>
}